import React, { FC } from 'react';
import classNames from 'classnames';

type Props = {
  selected: boolean;
  handleClick?: () => void;
};

export const PartiesSelector: FC<Props> = ({
  children,
  selected,
  handleClick,
}) => {
  return (
    <div
      className="search-filters-radio"
      {...(handleClick
        ? {
            onClick: handleClick,
          }
        : {})}
    >
      <i
        className={classNames('material-icons search-filters-radio__icon', {
          icons__radio_button_unchecked: !selected,
          icons__radio_button_checked: selected,
          'search-filters-radio__icon--selected': selected,
        })}
      />
      {children}
    </div>
  );
};
